import { isOneOfTags, isElementNode } from 'anodum';
import { EDITABLE_ELEMENTS } from '../constants/editable-elements';
import findPrevNode from './find-prev-node';
import findNextNode from './find-next-node';
import getElementFromNode from './get-element-from-node';
import injections from '../../hdrm/injections';

export const findEditableElement = (node) => {
  if (!node || !isElementNode(node)) return null;

  return isOneOfTags(node, EDITABLE_ELEMENTS) ? node : node.querySelector(EDITABLE_ELEMENTS);
};

export const findPrevEditableElement = (currentElement) => {
  const rootElement = injections.bindings.text.getRootTextElement(
    getElementFromNode(currentElement)
  );
  return findEditableElement(findPrevNode(currentElement, rootElement));
};

export const findNextEditableElement = (currentElement) => {
  const rootElement = injections.bindings.text.getRootTextElement(
    getElementFromNode(currentElement)
  );
  return findEditableElement(findNextNode(currentElement, rootElement));
};
